import { render, staticRenderFns } from "./VergelijkingspuntListView.vue?vue&type=template&id=0721d94e"
import script from "./VergelijkingspuntListView.vue?vue&type=script&lang=js"
export * from "./VergelijkingspuntListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports